var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec11Img2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 32.9041H3.22282M33.6886 32.9041H31.4658M3.22282 32.9041V25.3536C3.22282 25.3352 3.23773 25.3203 3.25613 25.3203H7.63516C7.65356 25.3203 7.66847 25.3352 7.66847 25.3536V32.9041M3.22282 32.9041H7.66847M7.66847 32.9041H11.4603M11.4603 32.9041V22.8693C11.4603 22.8509 11.4753 22.836 11.4936 22.836H15.3497C15.3681 22.836 15.383 22.8509 15.383 22.8693V32.9041M11.4603 32.9041H15.383M15.383 32.9041H19.4364M19.4364 32.9041V19.8619C19.4364 19.8435 19.4513 19.8286 19.4697 19.8286H23.4564C23.4748 19.8286 23.4897 19.8435 23.4897 19.8619V32.9041M19.4364 32.9041H23.4897M23.4897 32.9041H27.1509M27.1509 32.9041C27.1509 26.4748 27.1509 13.8955 27.1509 13.1888C27.1509 13.1704 27.1658 13.1602 27.1842 13.1602H31.4324C31.4508 13.1602 31.4658 13.1751 31.4658 13.1935V32.9041M27.1509 32.9041H31.4658M1 20.6131C15.383 19.8286 25.4511 13.1602 31.4658 1M31.4658 1L24.7973 3.22282M31.4658 1L33.6886 8.32224",
    stroke: "white",
    strokeWidth: 1.56905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec11Img2);
export default __webpack_public_path__ + "static/media/sec11img2.6c915b971c2ff5bf76095e0cbbac6568.svg";
export { ForwardRef as ReactComponent };